import React, { ForwardedRef, forwardRef, ReactNode, useMemo } from 'react';
import styles from '../Input.module.scss';
import cn from 'classnames';

const getErrorMessage = (error?: string | string[] | null) => {
  if (!error) return '';
  if (error instanceof Array) {
    return error.length ? error[0] : '';
  }
  return error;
};

export interface InputWrapperProps {
  children?: ReactNode;
  wrapperClassName?: string;
  labelClassName?: string;
  id?: string;
  name?: string;
  label?: string;
  touched?: boolean | boolean[];
  success?: string | null;
  successBoundary?: boolean;
  error?: string | string[] | null;
  errorBoundary?: boolean;
  messageClassName?: string;
  noMessages?: boolean;
  counting?: boolean;
  length?: number;
  maxLength?: number;
  additionalRowInside?: ReactNode;
  additionalRowOutside?: ReactNode;
}

function InputWrapper(props: InputWrapperProps, ref: ForwardedRef<HTMLDivElement>) {
  const {
    additionalRowInside,
    additionalRowOutside,
    wrapperClassName,
    labelClassName,
    label,
    touched,
    success,
    error,
    messageClassName,
    noMessages,
    children,
    id,
    name,
    counting,
    length,
    maxLength,
  } = props;

  const messageContainerClassName = cn(styles.message, messageClassName);
  const containerClassName = cn(styles.container, wrapperClassName);
  const errorMessage = useMemo(() => getErrorMessage(error), [error]);

  return (
    <div ref={ref} className={containerClassName}>
      {label ? (
        <label className={cn(labelClassName, styles.label)} htmlFor={id || name}>
          {label}
        </label>
      ) : null}
      {children}
      {!!additionalRowInside && additionalRowInside}
      {!noMessages && (
        <div className={messageContainerClassName}>
          {counting && (
            <span className={styles.messageCounting}>
              {length}/{maxLength}
            </span>
          )}
          {touched && error ? <span className={styles.messageError}>{errorMessage}</span> : null}
          {success ? <span className={styles.messageSuccess}>{success}</span> : null}
        </div>
      )}

      {!!additionalRowOutside && additionalRowOutside}
    </div>
  );
}

export default forwardRef<HTMLDivElement, InputWrapperProps>(InputWrapper);
